import YesPlanner from "../assets/logos/yes-planner.jpeg";
import NerdmaSystems from "../assets/projects/nerdma-systems.png";
import KuyaMarket from "../assets/projects/kuya-marketplace.png";
import RevoraGrowth from "../assets/projects/revora-growth.png";
import ayobaMarketPlace from "../assets/projects/ayoba-marketplace.png";
import lotusImpactLogo from "../assets/projects/lotus-impact-foundation.png";
import arteco from "../assets/projects/arteco-global.png";

export const projectsData = (isAyoba) => [
  {
    image: YesPlanner,
    isVisible: true,
    name: "Yes Planner",
    description: {
      en: "A modern wedding-planning platform designed to make venue discovery and planning feel clear, personal and effortless.",
      fr: "Une plateforme moderne d'organisation de mariage conçue pour rendre la découverte des lieux et la planification simples et personnelles.",
    },
    technologies: ["Angular", "Product design", "SEO"],
    relatedPostSlug: "yes-planner-build-notes",
    liveDemoLink: "https://www.yes-planner.com/",
  },
  {
    image: NerdmaSystems,
    isVisible: true,
    name: "Nerdma Systems",
    description: {
      en: "An Angular website delivered with a focus on responsive components, SEO, performance and maintainability.",
      fr: "Un site Angular conçu autour de composants responsives, du SEO, des performances et de la maintenabilité.",
    },
    technologies: ["Angular", "TypeScript", "SEO"],
    relatedPostSlug: "nerdma-systems-build-notes",
    liveDemoLink: "https://www.nerdma.co.za/",
  },
  {
    image: KuyaMarket,
    isVisible: true,
    name: "Kuya MarketPlace",
    description: {
      en: "A marketplace project presented as an evolving product and development case study.",
      fr: "Un projet de marketplace présenté comme une étude de produit et de développement en évolution.",
    },
    technologies: ["React", "Marketplace", "Web"],
    liveDemoLink: "https://kuja-market.vercel.app",
    relatedPostSlug: "building-kuya-with-purpose",
  },
  {
    image: RevoraGrowth,
    isVisible: !isAyoba,
    name: "Revora Growth",
    description: {
      en: "A public-facing growth platform and one of the portfolio's active product builds.",
      fr: "Une plateforme de croissance publique et l'un des produits actifs du portfolio.",
    },
    technologies: ["React", "Web Development"],
    liveDemoLink: "https://revora-growth.vercel.app",
  },
  {
    image: lotusImpactLogo,
    isVisible: true,
    name: "Lotus Impact Foundation",
    description: {
      en: "A nonprofit organisation website designed to communicate its work and make key information easy to reach.",
      fr: "Un site d'organisation à but non lucratif conçu pour présenter son action et rendre les informations essentielles accessibles.",
    },
    technologies: ["Next.js", "Responsive UI"],
    liveDemoLink: "https://lotus-impact-foundation.vercel.app",
  },
  {
    image: ayobaMarketPlace,
    isVisible: true,
    name: "Ayoba Marketplace",
    description: {
      en: "E-commerce platform work spanning API integration, delivery workflows, security, performance and interface improvements.",
      fr: "Travail sur une plateforme e-commerce couvrant les intégrations API, les déploiements, la sécurité, les performances et l'interface.",
    },
    technologies: ["C#", ".NET", "BoxCommerce APIs", "Docker"],
    liveDemoLink: "https://www.ayoba.me/",
  },
  {
    image: arteco,
    isVisible: true,
    name: "Arteco Global",
    description: {
      en: "Backend integrations for real-time video events, AI camera platforms and secure device communication.",
      fr: "Intégrations backend pour les événements vidéo en temps réel, les caméras IA et la communication sécurisée avec les appareils.",
    },
    technologies: ["C#", ".NET", "JWT", "Real-time APIs"],
    relatedPostSlug: "arteco-global-build-notes",
    liveDemoLink: "https://vms.usee.cloud/",
  },
];
